export const matchCentreComment = {
    data() {
        return {
            disableOnSubmit : false,
            comment: {
                type: 'comment',
                content: null,
                important: false,
                fixture: 1,
            },
            showModal: false,
            commentEdit: false,
            commentId: null,
            step: 1,
            matchComments: null,
            fixtureId: null,
            errorMessage: null,
            generalOnly: false,
        }

    },
    computed : {
        disableSubmit : function() {
            if (this.comment.content === null || this.comment.content === '') {
                return true;
            }
            return false;
        }
    },
    methods : {
        openModal(value = false) {
            if (value) {
                this.fixtureId = value;
            } else {
                this.generalOnly = true;
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.resetComment();
            this.fixtureId = null;
            this.commentId = null;
            this.commentEdit = false;
            this.generalOnly = false;
        },
        resetComment() {
            this.comment = {
                type: 'comment',
                content: null,
                important: false,
                fixture: 1,
            };
        },
        submitName(user, url) {
            var self = this;
            if(user.first_name.length <= 0 || user.last_name.length <= 0) {
                this.errorMessage = 'Both First Name and Last Name must be completed';
                setTimeout(function(){
                    self.errorMessage = null;
                }, 10000);
                return;
            }
            this.disableOnSubmit = true;
            axios
                .post(url,
                    {
                        first_name: user.first_name,
                        last_name: user.last_name
                    }
                )
                .then(response => {
                    this.disableOnSubmit = false;
                    this.step = 3;
                })
                .catch(error => {
                    console.log(error);
                    this.disableOnSubmit = false;
                });

        },
        submitComment(url) {
            this.disableOnSubmit = true;
            var self = this;

            if(self.comment.fixture !== '0') {
                url = url + '/' + self.fixtureId;
            }
            
            axios
                .post(url, self.comment )
                .then(response => {
                    self.closeModal();
                    self.disableOnSubmit = false;
                    setTimeout(function(){
                        self.getUpdates();
                    }, 3000);
                    self.message = 'Match comment has been saved';
                    self.comment.content = '';
                })
                .catch(error => {
                    console.log(error);
                    self.disableOnSubmit = false;
                });
        },
        muteComment(hashid, url) {
            var self = this;
            this.disableOnSubmit = true;
            var url = url + '/' + hashid;

            axios
                .post(url, { })
                .then(response => {
                    setTimeout(function(){
                        self.getUpdates();
                    }, 3000);
                    self.message = 'Comment has been muted';
                    this.disableOnSubmit = false;
                })
                .catch(error => {
                    console.log(error);
                    self.disableOnSubmit = false;
                });
        },
        editComment(comment) {
            this.commentEdit = true;
            this.comment.content = comment.content;
            this.commentId = comment.hashid;
            this.showModal = true;
        },
        updateComment(url) {
            this.disableOnSubmit = true;
            var self = this;

            var url = url + '/' + self.commentId;

            axios
                .put(url,{ content: self.comment.content} )
                .then(response => {
                    setTimeout(function(){
                        self.getUpdates();
                    }, 3000);
                    self.message = 'Comment has been updated';
                    self.comment.content = '';
                    this.closeModal();
                    this.disableOnSubmit = false;
                })
                .catch(error => {
                    console.log(error);
                    self.disableOnSubmit = false;
                });

        },
        
    }
}